import $ from 'jquery';
import 'slick-carousel';
import "slick-carousel/slick/slick.scss"

import '@fancyapps/fancybox'
import '@fancyapps/fancybox/dist/jquery.fancybox.css'

import "../css/style.scss";

function resizeVideo() {
  const w = window.innerWidth, h = window.innerHeight;
  const mv = document.getElementById('mv');
  if( w * .5625 > h ){
    mv.classList.remove('verti');
    mv.classList.add('horiz');
  }else{
    mv.classList.add('verti');
    mv.classList.remove('horiz');
  }
}

function loadVideo() {
  const vid_target = document.getElementsByTagName('video')[0];
  const src = vid_target.getElementsByTagName('source')[0].src || vid_target.src;
  let xhr = new XMLHttpRequest();
  xhr.open('GET', src, true);
  xhr.responseType = 'blob';
  xhr.onload = ev => {
    if (xhr.status == 200) {
      let resBlob = xhr.response;
      let viduri = (window.webkitURL || window.URL).createObjectURL(resBlob);
      if(vid_target.children[0]){
        vid_target.getElementsByTagName('source')[0].setAttribute('src', viduri);
      }else{
        vid_target.setAttribute('src', viduri);
      }
      vid_target.addEventListener('canplaythrough', function() {
        vid_target.volume = 0;
        vid_target.play();
      });
    }
  };
  xhr.send();
}

let resizeTimer = null;
window.addEventListener('resize', () => {
	clearTimeout( resizeTimer );
	resizeTimer = setTimeout(() => {
    resizeVideo();
	}, 100 );  
});

window.addEventListener('DOMContentLoaded', () => {
  resizeVideo();
})

window.addEventListener('load', () => {
  loadVideo();
})


class scrollFunc {
  constructor(elm){
    this.elm = elm;
  }

  check() {
    let el = this.elm;
    let offsetTop = 0;
    while (el) {
      offsetTop += el.offsetTop;
      el = el.offsetParent;
    }
    const top = offsetTop - window.pageYOffset;

    if ((top - window.innerHeight / 2) < 0) {
      return true;
    }else{
      return false;
    }
  }
}

const scrollr = document.querySelectorAll(".scrollr");
for(let i = 0, len = scrollr.length; i < len; i++){
  const _this = scrollr[i];
  const scrollfunc = new scrollFunc(_this);

  const checkScrollFlag = () => {
    const flag = scrollfunc.check();
    if(flag === true){
      _this.classList.add("active");
      window.removeEventListener("scroll", checkScrollFlag);
    }    
  }
  window.addEventListener("scroll", checkScrollFlag)
}

const easingEaseOutCubic = function (currentTime, startValue, changeValue, duration) {
  currentTime /= duration;
  currentTime--;
  return changeValue * (currentTime * currentTime * currentTime + 1) + startValue;
};

const scrollToAnchor = (ev) => {
  ev.preventDefault();
  document.querySelector('.sp_menu').classList.remove('show');
  const target = document.querySelector(ev.currentTarget.getAttribute('href'));
  let
    time = 0,
    currentScrollTop = window.pageYOffset,
    targetScrollTop = window.pageYOffset + target.getBoundingClientRect().top,
    scrollInterval = () => {
      time += 0.1;
      let ease = easingEaseOutCubic(time, currentScrollTop, targetScrollTop - currentScrollTop, 3) ;
      window.scrollTo(0, ease);
      if(time > 3) return;
      window.requestAnimationFrame(scrollInterval);
    };
  scrollInterval();
}

const anchors = document.querySelectorAll('.easeAnchor');
for(let i = 0, len = anchors.length; i < len; i++){
  anchors[i].addEventListener('click', scrollToAnchor);
}

let mouseMoveTimer = null;  
document.querySelector('.slick_wrapper').addEventListener('mousemove', (ev) => {
  window.clearTimeout(mouseMoveTimer);
  mouseMoveTimer = setTimeout(() => {
    const mouseX = ev.clientX;
    if(0 <= mouseX && mouseX <= 50){
      document.querySelector('.slick-prev').classList.add('active')
    }else{
      document.querySelector('.slick-prev').classList.remove('active')
    }
    if((window.innerWidth - 50) <= mouseX && mouseX <= window.innerWidth){
      document.querySelector('.slick-next').classList.add('active')
    }else{
      document.querySelector('.slick-next').classList.remove('active')
    }
  }, 30);
})

document.querySelector('.hamburger').addEventListener('click', () => {
  document.querySelector('.sp_menu').classList.toggle('show');
})

window.addEventListener("scroll", () => {
  const photography = document.getElementById('photography');
  const scrolltop = window.pageYOffset;
  if(photography.getBoundingClientRect().top < 50){
    document.querySelector('.sp_menu').classList.add('re');
  }else{
    document.querySelector('.sp_menu').classList.remove('re');
  }
  const slickFlag = new scrollFunc(photography).check();
  if(slickFlag === true){
    $('.slick_wrapper').slick('slickPlay');
  }else{
    $('.slick_wrapper').slick('slickPause');
  }
})

$('.slick_wrapper').slick({
  autoplay: false
});  

$('[data-fancybox="images"]').fancybox({
  arrows: false,
  infobar: false,
  toolbar: false,
  touch: false,
  smallBtn: false,
  wheel: false,
  afterShow: () => {
    const closeBtn = document.createElement('div');
    closeBtn.classList.add('fancybox-custom-button');
    $('.fancybox-content').append(closeBtn);
    $('.fancybox-custom-button').on('click', () => {
      console.log('Run')
      $.fancybox.getInstance().close();
    })  
  },
  beforeClose: () => {
    $('.fancybox-custom-button').remove();
  }
});
